define('ch_accordion',[], function() {
    let accordions;
    let generatedContentIds = 0;

    return {
        init: function () {
            accordions = accordions || document.querySelectorAll('.accordion-mobile');

            accordions.forEach((el) => {
                const header = el.querySelector('.accordion-header');
                const content = el.querySelector('.accordion-content');

                if (!header || !content) {
                    return;
                }

                // The toggle has to be a real button. Click used to be bound to the
                // heading element itself, which is not focusable and does not respond
                // to Enter or Space, so every collapsed section on mobile was
                // unreachable for keyboard and switch users.
                let toggle = header.querySelector('.accordion-header__toggle');
                if (!toggle) {
                    toggle = document.createElement('button');
                    toggle.type = 'button';
                    toggle.classList.add('accordion-header__toggle');

                    while (header.firstChild) {
                        toggle.appendChild(header.firstChild);
                    }

                    header.appendChild(toggle);
                }

                let dropdown = toggle.querySelector('.icon.dropdown');
                if (!dropdown) {
                    dropdown = document.createElement('i');
                    dropdown.classList.add('ui');
                    dropdown.classList.add('icon');
                    dropdown.classList.add('dropdown');
                    toggle.appendChild(dropdown);
                }

                if (!content.id) {
                    generatedContentIds += 1;
                    content.id = 'accordion-content-' + generatedContentIds;
                }

                toggle.setAttribute('aria-controls', content.id);

                let isActive = el.classList.contains('accordion-mobile-active');

                const applyState = () => {
                    content.style.display = isActive ? 'block' : 'none';
                    toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
                    el.classList.toggle('accordion-mobile-active', isActive);
                };

                toggle.addEventListener('click', function() {
                    isActive = !isActive;
                    applyState();
                });

                applyState();
            });
        },
    };
});

